import AdjustmentItemRow from './adjustment.item.row.component';
import AdjustmentGroupTabs from './adjustment.group.tabs.component';
import AdjustmentEmptyCatalog from './adjustment.empty.catalog.component';
import { acceptsManyEntries } from './use.adjustment.sheet';

const entriesOf = (sheet, item) => sheet.selection.filter(entry => entry.catalogItemId === item.id);

const rowsFor = (sheet, item) => {
    const entries = entriesOf(sheet, item);

    if (!entries.length)
        return [{ key: item.id, entry: null, option: null }];

    return entries.map(entry => ({ key: [item.id, entry.entryId].join('-'), entry, option: sheet.optionOf(entry) }));
}

const acceptsMore = (sheet, item) =>
    acceptsManyEntries(item) && item.available && entriesOf(sheet, item).length > 0;

const AddMoreButtons = ({ sheet }) => (
    <>
        {sheet.itemsOfGroup.filter(item => acceptsMore(sheet, item)).map(item => (
            <button
                key={['add-more', item.id].join('-')}
                type="button"
                onClick={() => sheet.toggle(item)}
                className="self-start text-xs text-[#376fd0]"
            >
                + Acrescentar outra: {item.label}
            </button>
        ))}
    </>
);

export default function AdjustmentCatalogList({ sheet }) {

    if (sheet.catalog.length === 0)
        return <AdjustmentEmptyCatalog />;

    return (
        <>
            {sheet.groups.length > 1 && (
                <AdjustmentGroupTabs groups={sheet.groups} selectedGroup={sheet.selectedGroup} onSelectGroup={sheet.selectGroup} />
            )}

            <div className="flex flex-col gap-3">
                {sheet.itemsOfGroup.flatMap(item => rowsFor(sheet, item).map(row => (
                    <AdjustmentItemRow
                        key={row.key}
                        item={item}
                        entry={row.entry}
                        option={row.option}
                        pieceOptions={sheet.pieceOptions}
                        onToggle={sheet.toggle}
                        onRemove={sheet.removeEntry}
                        onChangePiece={sheet.changePiece}
                    />
                )))}

                <AddMoreButtons sheet={sheet} />
            </div>
        </>
    );
}
